import { render, staticRenderFns } from "./ClientCabinLayout.vue?vue&type=template&id=28ec1f97&"
import script from "./ClientCabinLayout.vue?vue&type=script&lang=ts&"
export * from "./ClientCabinLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCabinLayout.vue?vue&type=style&index=0&id=28ec1f97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports